import { render, staticRenderFns } from "./WinthorAutocomplete.vue?vue&type=template&id=63cb763b"
import script from "./WinthorAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./WinthorAutocomplete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports